import useRequiredParams from '@common/hooks/use-required-params';
import { Button, Stack } from '@mui/material';
import { AccessStatus, useGetAccessRequest } from '@client-app-sdk';
import { Loader } from '@common/ui/Loader';
import RequestTitle from '@MyRequests/components/RequestTitle';
import RequestContent from '@MyRequests/organisms/RequestContent';
import { Page } from '@common/ui/Page';
import { useMemo, useState } from 'react';
import Fade from '@mui/material/Fade';

export default function OnboardingAccessRequestPage() {
  const { id } = useRequiredParams(['id']);
  const { data, isFetched, error } = useGetAccessRequest(id, 1000);
  const [viewedCredentials, setViewedCredentials] = useState(false);

  const handleButtonClick = (type: string) => {
    window.parent.postMessage(
      {
        type,
      },
      ADMIN_PORTAL_URL || '*',
    );
  };
  const isPending = useMemo(
    () => data?.status.status === AccessStatus.Pending || data?.status.status === AccessStatus.PENDING,
    [data],
  );
  const isGranted = useMemo(
    () => data?.status.status === AccessStatus.Active || data?.status.status === AccessStatus.GRANTED,
    [data],
  );
  const isApproved = useMemo(
    () => data?.status.status === AccessStatus.Granting || data?.status.status === AccessStatus.APPROVED,
    [data],
  );

  const canFinishOnboarding = useMemo(
    () => !(isPending || isApproved || (isGranted && !viewedCredentials)),
    [isApproved, isGranted, isPending, viewedCredentials],
  );

  if (!isFetched) {
    return <Loader />;
  }

  const handleOnDetailsExpand = () => {
    setTimeout(() => {
      setViewedCredentials(true);
    }, 1000);
  };

  return (
    <Page title="You did it!">
      <Stack direction="column" spacing={2} width="48rem">
        <RequestTitle requestId={id} />
        <RequestContent
          {...{
            data,
            error,
            isFetched,
            onDetailsExpand: handleOnDetailsExpand,
            initNewCreds: isGranted && !viewedCredentials,
          }}
        />
        <Stack direction="row" spacing={2} marginTop={4} justifyContent="flex-end">
          {canFinishOnboarding && (
            <Fade in={true} timeout={500}>
              <Button variant="contained" onClick={() => handleButtonClick('next-button')}>
                Finish onboarding
              </Button>
            </Fade>
          )}
        </Stack>
      </Stack>
    </Page>
  );
}
